/**
 * Image Processor Utility
 * Handles optimization and format conversion (WebP)
 */

export const convertToWebP = (file, options = {}) => {
    return new Promise((resolve, reject) => {
        const { maxWidth = 1920, quality = 0.8, ratio = null } = options;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;

                // 1. Resize Logic
                if (width > maxWidth) {
                    height = Math.round(height * (maxWidth / width));
                    width = maxWidth;
                }

                // 2. Crop Logic (Aspect Ratio)
                let sx = 0, sy = 0, sWidth = img.width, sHeight = img.height;

                if (ratio) {
                    const [rw, rh] = ratio.split(':').map(Number);
                    const targetRatio = rw / rh;
                    const currentRatio = width / height;

                    if (currentRatio > targetRatio) {
                        // Image is wider than target -> Crop width
                        const newSWidth = sHeight * targetRatio;
                        sx = (sWidth - newSWidth) / 2;
                        sWidth = newSWidth;
                    } else {
                        // Image is taller than target -> Crop height
                        const newSHeight = sWidth / targetRatio;
                        sy = (sHeight - newSHeight) / 2;
                        sHeight = newSHeight;
                    }
                }

                canvas.width = width;
                canvas.height = ratio ? width / (ratio.split(':')[0] / ratio.split(':')[1]) : height;

                const ctx = canvas.getContext('2d');
                // Draw cropped image
                ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, canvas.width, canvas.height);

                // 3. Convert to WebP
                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error('WebP Conversion Failed'));
                    }
                }, 'image/webp', quality);
            };

            img.onerror = (err) => reject(err);
        };
        reader.onerror = (err) => reject(err);
    });
};
